import { ButtonHeadless, Modal } from '@wajeez-web/components/ui';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { BiLoaderAlt } from 'react-icons/bi';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  message: string;
  isLoading?: boolean;
}

export const ConfirmationModal = ({
  isOpen,
  onClose,
  onSubmit,
  message,
  isLoading,
}: ConfirmationModalProps) => {
  return (
    <Modal
      title="Confirmation"
      withScroll={false}
      open={isOpen}
      onClose={onClose}
      handleAlert={false}
      fontClassName="font-[Tajawal]"
    >
      <div className="font-[Tajawal]">
        <h1 className="font-normal text-[18px]">
          <ReturnTranslatedText
            origintext={message}
            text={`general.${message}`}
          />
        </h1>
        <div className="mt-6 w-full flex justify-end items-center">
          <div className="w-[90px]">
            <ButtonHeadless
              paddingYStyle="py-1"
              borderRadiusStyle="rounded-[6px]"
              action={onSubmit}
              isDisabled={isLoading}
            >
              <div className="w-full flex justify-center items-center space-s-1 text-white text-[16px] font-medium">
                <ReturnTranslatedText
                  origintext="Ok"
                  text={`buttons.${'Ok'}`}
                />
                {isLoading && <BiLoaderAlt className="animate-spin w-5" />}
              </div>
            </ButtonHeadless>
          </div>
          <div className="w-[90px] rtl:mr-4 ltr:ml-4">
            <ButtonHeadless
              paddingYStyle="py-1"
              bgStyle="bg-warmGray-300"
              borderRadiusStyle="rounded-[6px]"
              action={onClose}
            >
              <div className="w-full flex justify-center items-center text-warmGray-500 text-[16px] font-bold">
                <ReturnTranslatedText
                  origintext="Cancel"
                  text={`buttons.${'Cancel'}`}
                />
              </div>
            </ButtonHeadless>
          </div>
        </div>
      </div>
    </Modal>
  );
};
